import { eachQuarterOfInterval, startOfQuarter, endOfQuarter, startOfYear, compareAsc, subQuarters, endOfDay, format } from "date-fns";

export const previousQuarterForCurrentYear = () => {
    const currentDate = new Date();
    const previousQuarterStart = startOfQuarter(subQuarters(currentDate, 1));
    const previousQuarterEnd = endOfQuarter(previousQuarterStart);
    return {
        startDate: previousQuarterStart,
        endDate: previousQuarterEnd
    }
}

export const getFirstMonthNumbersForEachQuarter = (year: number) => {
    const quarters = [1, 2, 3, 4];
    const firstMonths = quarters.map((quarter) => {
      const date = new Date(year, (quarter - 1) * 3, 1);
      return Number(format(date, 'M'));
    });
  
    return firstMonths;
  };

export const getDatesForKpiTrends = () => {
    const today = new Date();

    const startOfCurrentQuarter = startOfQuarter(today);

    const previousQuarterStart = subQuarters(startOfCurrentQuarter, 1);
    const previousQuarterEnd = endOfQuarter(previousQuarterStart);

    const previousToPreviousQuarterStart = subQuarters(startOfCurrentQuarter, 2);
    const previousToPreviousQuarterEnd = endOfQuarter(previousToPreviousQuarterStart);

    return {
        pq: {
            startDate: previousQuarterStart,
            endDate: previousQuarterEnd
        },
        p2pq: {
            startDate: previousToPreviousQuarterStart,
            endDate: previousToPreviousQuarterEnd
        }
    }
}

export const getCustomRanges = (year: number) => {
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31);

    const quarters = eachQuarterOfInterval({ start: startDate, end: endDate });

    const today = endOfDay(new Date());
    const previousQuarter = previousQuarterForCurrentYear();
    const quarterRanges = quarters.map((quarter, index) => {
        let startDate = startOfQuarter(quarter);
        let endDate = endOfQuarter(quarter);

        let endDateResitriction = compareAsc(endDate, today);
        if (endDateResitriction === 1 || endDateResitriction === 0) {
            endDate = today;
        }

        return {
            label: `Quarter ${index + 1}, ${year}`,
            hasCusstomRendering: false,
            range: () => ({
                startDate,
                endDate
            }),
            isSelected() {
                return compareAsc(previousQuarter.startDate, startDate) === 0
                    && compareAsc(previousQuarter.endDate, endDate) === 0;
            }
        }
    });

    const YearTillDate = {
        label: 'Year to date',
        hasCusstomRendering: false,
        range: () => ({
            startDate: startOfYear(today),
            endDate: today
        }),
        isSelected: () => {
            return false;
        }
    }

    return [...quarterRanges.filter(r => r !== null), YearTillDate]
}


export const highlightSelectedDateRange = (selectedStartDate: Date, selectedEndDate: Date, staticRanges: any[]) => {
    const updated = staticRanges.map((range: any) => {
        const { startDate, endDate } = range.range();
        return {
            ...range,
            isSelected: () => {
                return compareAsc(startDate, selectedStartDate) === 0
                    && compareAsc(endDate, selectedEndDate) === 0;
            }
        }
    })
    return updated;
}